import { BOP_HIRED_NON_OWNED_AUTO_COVER, BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER, BOP_PROPERTY, BUSINESS_OWNERS_POLICY_CLAIM_COVER, BUSINESS_OWNERS_POLICY_COVER, CL_EXCESS_COVER, CRIME_COVER, CRIME_EXCESS_COVER, CYBER_LIABILITY_COVER, PROFESSIONAL_INDEMNITY, PROFESSIONAL_INDEMNITY_CLAIM_COVER, PROPERTY_EXCESS_COVER, PUBLIC_LIABILITY, PUBLIC_LIABILITY_CLAIM_COVER } from '../../constants/coverage';
export var getProfessionalIndemnityDisplayText = function getProfessionalIndemnityDisplayText(config) {
  return (config === null || config === void 0 ? void 0 : config.initialText) || 'Professional Indemnity';
};
export var getPublicLiabilityDisplayText = function getPublicLiabilityDisplayText(config) {
  return (config === null || config === void 0 ? void 0 : config.initialText) || 'Public Liability';
};
export var getEmployersLiabilityDisplayText = function getEmployersLiabilityDisplayText(config) {
  return (config === null || config === void 0 ? void 0 : config.initialText) || 'Employers Liability';
};
export var getExcessLevelDisplayText = function getExcessLevelDisplayText(config) {
  return (config === null || config === void 0 ? void 0 : config.initialText) || 'Excess Level';
};
export var getGoodsInTransitDisplayText = function getGoodsInTransitDisplayText(config) {
  return (config === null || config === void 0 ? void 0 : config.initialText) || 'Goods in transit';
};
export var getCmrCoverDisplayText = function getCmrCoverDisplayText(config) {
  return (config === null || config === void 0 ? void 0 : config.initialText) || 'CMR Cover';
};
export var getHireAndRewardDisplayText = function getHireAndRewardDisplayText(config) {
  return (config === null || config === void 0 ? void 0 : config.initialText) || 'Hire And Reward';
};
export var checkHiscoxUSCoverageValidInfo = function checkHiscoxUSCoverageValidInfo() {
  var coverageInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var validateCoverageDataInfo = {};

  function isSelectedCoverageWithValue(coverageInfo, coverageKey) {
    var _coverageInfo$coverOp;

    return !!coverageInfo[coverageKey] && ((coverageInfo === null || coverageInfo === void 0 ? void 0 : (_coverageInfo$coverOp = coverageInfo.coverOptions) === null || _coverageInfo$coverOp === void 0 ? void 0 : _coverageInfo$coverOp[coverageKey]) || []).find(function (item) {
      return item.value === coverageInfo[coverageKey];
    });
  } // pi


  if (isSelectedCoverageWithValue(coverageInfo, PROFESSIONAL_INDEMNITY) && !isSelectedCoverageWithValue(coverageInfo, PROFESSIONAL_INDEMNITY_CLAIM_COVER)) {
    validateCoverageDataInfo[PROFESSIONAL_INDEMNITY_CLAIM_COVER] = {
      value: PROFESSIONAL_INDEMNITY_CLAIM_COVER
    };
  } // pl


  if (isSelectedCoverageWithValue(coverageInfo, PUBLIC_LIABILITY) && !isSelectedCoverageWithValue(coverageInfo, PUBLIC_LIABILITY_CLAIM_COVER)) {
    validateCoverageDataInfo[PUBLIC_LIABILITY_CLAIM_COVER] = {
      value: PUBLIC_LIABILITY_CLAIM_COVER
    };
  } // bop


  if (isSelectedCoverageWithValue(coverageInfo, BUSINESS_OWNERS_POLICY_COVER) && !isSelectedCoverageWithValue(coverageInfo, BUSINESS_OWNERS_POLICY_CLAIM_COVER)) {
    validateCoverageDataInfo[BUSINESS_OWNERS_POLICY_CLAIM_COVER] = {
      value: BUSINESS_OWNERS_POLICY_CLAIM_COVER
    };
  }

  if (isSelectedCoverageWithValue(coverageInfo, BUSINESS_OWNERS_POLICY_COVER) && !isSelectedCoverageWithValue(coverageInfo, BOP_PROPERTY)) {
    validateCoverageDataInfo[BOP_PROPERTY] = {
      value: BOP_PROPERTY
    };
  }

  if (isSelectedCoverageWithValue(coverageInfo, BUSINESS_OWNERS_POLICY_COVER) && !isSelectedCoverageWithValue(coverageInfo, PROPERTY_EXCESS_COVER)) {
    validateCoverageDataInfo[PROPERTY_EXCESS_COVER] = {
      value: PROPERTY_EXCESS_COVER
    };
  }

  if (isSelectedCoverageWithValue(coverageInfo, BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER) && !isSelectedCoverageWithValue(coverageInfo, BOP_HIRED_NON_OWNED_AUTO_COVER)) {
    validateCoverageDataInfo[BOP_HIRED_NON_OWNED_AUTO_COVER] = {
      value: BOP_HIRED_NON_OWNED_AUTO_COVER
    };
  }

  if (isSelectedCoverageWithValue(coverageInfo, CRIME_EXCESS_COVER) && !isSelectedCoverageWithValue(coverageInfo, CRIME_COVER)) {
    validateCoverageDataInfo[CRIME_COVER] = {
      value: CRIME_COVER
    };
  } // Cyber


  if (isSelectedCoverageWithValue(coverageInfo, CYBER_LIABILITY_COVER) && !isSelectedCoverageWithValue(coverageInfo, CL_EXCESS_COVER)) {
    validateCoverageDataInfo[CL_EXCESS_COVER] = {
      value: CL_EXCESS_COVER
    };
  }

  return validateCoverageDataInfo;
};